import { Button } from "react-bootstrap";
import { FileStatus } from "../../type/FileStatusType";
import { Trans } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { PAGE } from "../../constants/page";
import { selectedStatePractioner } from "../../redux/reducers/PractionerRoleIdsSlice";
import { useAppSelector } from "../../redux/hooks";
interface UploadCSVSuccessType {
  changeFileStatus: (fileStatus: FileStatus) => void;
}

const UploadCSVSuccess = ({ changeFileStatus }: UploadCSVSuccessType) => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedState = useAppSelector(selectedStatePractioner);

  const goToDashboard = () => {
    let routeLink;
    routeLink = location.pathname.includes("/admin")
      ? PAGE.GLOBAL_STATE_ADMIN.replace(
          ":state",
          selectedState.stateId.label.concat("/admin")
        )
      : `${PAGE.STATE_ADMIN}/asha`;
    navigate(routeLink);
  };
  return (
    <>
      <img
        src="/icons/SuccessIcon.svg"
        alt="successIcon"
        className="addUserSuccessIcon"
      />
      <div className="successTitle">
        <Trans i18nKey={"file_uploaded"} />
      </div>
      <Button
        variant="outline"
        className="uploadButton"
        data-testid="uploadButtonTest"
        onClick={() => {
          changeFileStatus(FileStatus.INIT);
          goToDashboard();
        }}
      >
        <Trans i18nKey={"go_to_dashboard"} />
      </Button>
    </>
  );
};

export default UploadCSVSuccess;
